import type { SvgIconComponent } from "@mui/icons-material"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import MenuItem from "@mui/material/MenuItem"

export default function NavigationRow({
  text,
  Icon,
  onClick
}: {
  Icon: SvgIconComponent
  text: string
  onClick: () => Promise<void> | void
}) {
  return (
    <MenuItem onClick={onClick}>
      <ListItemIcon>
        <Icon />
      </ListItemIcon>
      <ListItemText>{text}</ListItemText>
    </MenuItem>
  )
}
